import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from '@modules/auth/login/login.component';
import { isAuthenticatedGuard, isNotAuthenticatedGuard } from '@shared/guards/auth.guard';

const routes: Routes = [
  { path: '', component: LoginComponent, canActivate: [isNotAuthenticatedGuard] },
  { path: 'login', component: LoginComponent, canActivate: [isNotAuthenticatedGuard] },
  {
    path: 'auth',
    loadChildren: () => import('@modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'home',
    loadChildren: () => import('@modules/home/home.module').then((m) => m.HomeModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'cadastro',
    loadChildren: () => import('@modules/cadastro/cadastro.module').then((m) => m.CadastroModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'adm',
    loadChildren: () => import('@modules/adm/adm.module').then((m) => m.AdmModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'investor-register',
    loadChildren: () =>
      import('@modules/cadastro/components/investors/investors.module').then(
        (m) => m.InvestorsModule,
      ),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: 'cadastro-investidor',
    loadChildren: () =>
      import('@modules/cadastro/components/investors/simplified-registration/simplified-registration.module').then(
        (m) => m.SimplifiedRegistrationModule,
      ),
  },
  {
    path: 'prova-de-vida',
    loadChildren: () =>
      import('@modules/liveness/liveness.module').then((m) => m.LivenessModule),
  },
  {
    path: 'clients',
    loadChildren: () => import('@modules/clients/clients.module').then((m) => m.ClientsModule),
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
